import React from 'react';

import { expenseFormService } from '@splitfiesta/core';
import { useTranslation } from '@splitfiesta/i18n';
import { Card } from '@splitfiesta/ui';

import { DatePicker } from '@/components/common/DatePicker';
import { AiTag } from '@/components/expenses/receipt/AiTag';

interface ExpenseDateProps {
  date: string;
  setDate: (value: string) => void;
  isLoading: boolean;
  /** The receipt scan filled the date. */
  aiTagged?: boolean;
}

export function ExpenseDate({
  date,
  setDate,
  isLoading,
  aiTagged = false,
}: ExpenseDateProps) {
  const { t } = useTranslation('expenses');

  return (
    <Card>
      {/* 1/3 width on desktop — a leftover grid column from when this
          card also held the currency field (moved beside the amount). */}
      <div className="sm:w-1/3">
        <DatePicker
          id="date"
          label={t('fields.date')}
          labelAccessory={
            aiTagged ? (
              <span className="ml-2 align-middle">
                <AiTag />
              </span>
            ) : undefined
          }
          value={date}
          onChange={setDate}
          max={expenseFormService.getLocalDateString()}
          required
          disabled={isLoading}
          data-testid="expense-date-input"
        />
      </div>
    </Card>
  );
}

export default ExpenseDate;
